import OptableColumnManager from '../optable/OptableColumnManager';

export default class OptInColumnManager extends OptableColumnManager {
  constructor(session, counterparty) {
    super(session, counterparty, 'isOptedOut', 'Opt Out');
  }
}